module.exports = __webpack_public_path__ + "static/img/banne2.fb1cb844.png";